import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { alert } from "../../models/alert";
import {AlertaService} from "../../services/alerta.service";
import {ProyectoService} from "../../services/proyecto.service";
import {Navigation} from "../../services/navigation.service";
import {PlanoService} from "../../services/plano.service";
import {ZonaService} from "../../services/zona.service";
import {plano} from "../../models/plano";
import {zona} from "../../models/zona";
import {UserService} from "../../services/user.service";
import {Localiser} from "../../services/localiser";
import {sensor} from "../../models/sensor";
import {SensorService} from "../../services/sensor.service";

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css']
})
export class AlertsComponent implements AfterViewInit {

  pendingAlertsBool: boolean = true;
  solvedAlertsBool: boolean = false;
  showGateways: boolean = true;
  showLuminaires: boolean = true;
  showSensors: boolean = true;
  planoSelected: plano = undefined;
  zonaSelected: zona = undefined;

  alerts: Array<alert> = [];
  alertsFilter: Array<alert> = [];
  alertsNumber: number = undefined;
  loadingAlerts: boolean = true;
  actualPage: number = 1;
  planos: Array<plano> = [];
  zonas: Array<zona> = [];
  zonasReal: Array<zona> = [];
  pendingAlerts: Array<alert> = [];
  solvedAlerts: Array<alert> = [];
  sensors: Array<sensor> = [];

  newAlertCheck: boolean = false;
  closeAlertCheck: boolean = false;

  constructor(public localiser: Localiser, public alertaService: AlertaService, public proyectoService: ProyectoService,
              public navigation: Navigation, public planoService: PlanoService, public zonaService: ZonaService,
              public user: UserService, public sensorService: SensorService, private  changeDetectorRef: ChangeDetectorRef) {
    if (!this.proyectoService.proyectoActualCookie()) {
      proyectoService.setTrueSelectALocation("alerts");
      this.toLocations();
    } else {
      proyectoService.setLastPage("alerts")
    }

  }

  ngAfterViewInit(): void {
    this.getSensors();
    this.getPlanosAndZonas();
    this.getChecks();
  }

  getSensors() {
    this.sensorService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<sensor>) => {
      this.sensors = result;
      this.getAlerts();
    })
  }

  getAlerts() {
    this.alertaService.getCountByIDProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: number) => {
      this.alertsNumber = result;
      if (this.alertsNumber > 100) {
        this.getAlertsPaginatedRecursive(1);
      }
    });
    this.getAlertsPaginated(0);
  }

  getAlertsPaginatedRecursive(page) {
    if (page < Math.ceil(this.alertsNumber / 100)) {
      this.getAlertsPaginated(page);
      this.getAlertsPaginatedRecursive(page + 1);
    }
  }

  getAlertsPaginated(page) {
    this.alertaService.getByIDProyectoPaginated(this.proyectoService.getProyectoActual().idProyecto, page).subscribe((result: Array<alert>) => {
      for (let alerta of result) {
        if (alerta.estado == 'Pending') {
          this.pendingAlerts.push(alerta);
        } else {
          this.solvedAlerts.push(alerta);
        }
      }
      if (this.alertsNumber == this.pendingAlerts.length + this.solvedAlerts.length) {
        this.loadingAlerts = false;
      }
      this.loadAlertsList();
    })
  }

  getPlanosAndZonas() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<plano>) => {
      this.planos = result;
    })
    this.zonaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<zona>) => {
      this.zonasReal = result;
      this.zonas = this.zonasReal;
    })
  }

  getPlano(idPlano) {
    let plano: plano = this.planos.find(plano => plano.idPlano == idPlano);
    if (idPlano != -1 && plano != undefined) {
      return plano.nombre;
    } else {
      return '--';
    }
  }

  getZona(idZona) {
    let zona: zona = this.zonas.find(zona => zona.id == idZona);
    if (idZona != -1 && zona != undefined) {
      return zona.nombre;
    } else {
      return '--';
    }
  }

  getEstado(estado) {
    if (estado == 'Pending') {
      return this.localiser.get("alerts.statusPending");
    } else if (estado == 'Solved') {
      return this.localiser.get("alerts.statusSolved");
    }
  }

  changePendingAlerts() {
    this.pendingAlertsBool = !this.pendingAlertsBool;
    this.loadAlertsList();
  }

  changeSolvedAlerts() {
    this.solvedAlertsBool = !this.solvedAlertsBool;
    this.loadAlertsList();
  }

  getUnidadMedidaById(idDispositivo) {
    let sensor = this.sensors.find(sensor => sensor.idLuminaria == idDispositivo);
    if (sensor != undefined) {
      return sensor.unidadMedida;
    }
    return "";
  }

  changeShowLuminaires(event) {
    this.showLuminaires = event.checked;
    this.loadAlertsList();
  }

  changeShowGateways(event) {
    this.showGateways = event.checked;
    this.loadAlertsList();
  }

  changeShowSensors(event) {
    this.showSensors = event.checked;
    this.loadAlertsList();
  }

  selectPlano(event) {
    if (event.value == 'all') {
      this.planoSelected = undefined;
      this.zonaSelected = undefined;
      this.zonas = this.zonasReal;
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == event.value.idPlano);
      this.zonas = this.zonasReal.filter(zona => zona.idPlano == event.value.idPlano);
      if (this.zonaSelected != null && !this.zonas.includes(this.zonaSelected))
        this.zonaSelected = undefined
    }
    this.loadAlertsList();
  }

  selectZona(event) {
    if (event.value == 'all') {
      this.zonaSelected = undefined;
    } else {
      this.zonaSelected = this.zonas.find(zona => zona.id == event.value.id);
      if (this.planoSelected == null) {
        this.planoSelected = this.planos.find(plano => plano.idPlano == this.zonaSelected.idPlano);
        this.zonas = this.zonasReal.filter(zona => zona.idPlano == this.zonaSelected.idPlano);
      }
    }
    this.loadAlertsList();
  }

  changeAlertToSolved(id: string) {
    this.alertaService.changeEstado(id, true).subscribe(result => {
      let alert = this.pendingAlerts.find(alert => alert.idAlertaFinal === id);
      const index = this.pendingAlerts.indexOf(alert, 0);
      if (index > -1) {
        this.pendingAlerts.splice(index, 1);
      }
      alert.estado = 'Solved';
      this.solvedAlerts.push(alert);
      this.loadAlertsList();
    });
  }

  changeAlertToPending(id: string) {
    this.alertaService.changeEstado(id, false).subscribe(result => {
      let alert = this.solvedAlerts.find(alert => alert.idAlertaFinal === id);
      const index = this.solvedAlerts.indexOf(alert, 0);
      if (index > -1) {
        this.solvedAlerts.splice(index, 1);
      }
      alert.estado = 'Pending';
      this.pendingAlerts.push(alert);
      this.loadAlertsList();
    });
  }

  loadAlertsList() {
    this.alertsFilter = [];
    if (this.pendingAlertsBool)
      this.alertsFilter = this.alertsFilter.concat(this.pendingAlerts);
    if (this.solvedAlertsBool)
      this.alertsFilter = this.alertsFilter.concat(this.solvedAlerts);
    if (!this.showLuminaires)
      this.alertsFilter = this.alertsFilter.filter(alert => alert.tipoDispositivo != 'Luminaire')
    if (!this.showGateways)
      this.alertsFilter = this.alertsFilter.filter(alert => alert.tipoDispositivo != 'Gateway')
    if (!this.showSensors)
      this.alertsFilter = this.alertsFilter.filter(alert => alert.tipoDispositivo != 'Sensor')
    if (this.planoSelected != null)
      this.alertsFilter = this.alertsFilter.filter(alert => alert.idPlano == this.planoSelected.idPlano)
    if (this.zonaSelected != null)
      this.alertsFilter = this.alertsFilter.filter(alert => alert.idZona == this.zonaSelected.id)

    this.alertsFilter = this.alertsFilter.sort(function(a, b){
      // @ts-ignore
      return (b.timeLastComFinal - a.timeLastComFinal)});

    this.paginateAlerts(1, 100);
  }

  /*
    Show only 100 alerts in the list
   */
  paginateAlerts(page, n) {
    if (page > Math.ceil(this.alertsFilter.length / n)) {
      page = Math.ceil(this.alertsFilter.length / n);
    }
    if (page < 1 || page == undefined) {
      page = 1;
    }
    this.actualPage = undefined;
    this.changeDetectorRef.detectChanges();
    this.actualPage = page;
    this.alerts = this.alertsFilter.slice(n * (page - 1), n * page);
  }

  changePageByNumber(page) {
    if (page != undefined) {
      this.actualPage = undefined;
      this.changeDetectorRef.detectChanges();
      this.paginateAlerts(page, 100);
    }
  }

  outInputChangePageByNumber(event) {
    if (isNaN(event.srcElement.valueAsNumber)) {
      this.paginateAlerts(1, 100);
    }
  }

  changePageByArrow(nextPage: number) {
    this.paginateAlerts(this.actualPage + nextPage, 100);
  }

  isLastPage() {
    return Math.ceil(this.alertsFilter.length / 100) == this.actualPage || Math.ceil(this.alertsFilter.length / 100) <= 1;
  }

  setCheck(event) {
    this.user.setCheck(this.proyectoService.getProyectoActual().idProyecto, event.source.id, event.checked).subscribe(result => { })
  }

  getChecks() {
    this.user.getChecks(this.proyectoService.getProyectoActual().idProyecto,
      new Array<string>("newAlert", "closeAlert")).subscribe(result => {
      let jsonResult: JSON = JSON.parse(result);
      this.newAlertCheck = jsonResult["newAlert"];
      this.closeAlertCheck = jsonResult["closeAlert"];
    });
  }

  getTipoDispositivo(tipo) {
    if (tipo == "Luminaire") {
      return this.localiser.get("alerts.luminaire");
    } else if (tipo == "Sensor") {
      return this.localiser.get("alerts.sensor");
    } else if (tipo == "Gateway") {
      return this.localiser.get("alerts.gateway");
    }
  }

  toLocations() {
    this.navigation.toLocations();
  }

}
